import Callout from '../callout/Callout';
import PropTypes from 'prop-types';
import React from 'react';
import SwiperButton from '../swiperButton/SwiperButton';
import { generateRoutePath } from '@epic-core/common';

const MapsSectionBlock = ({block, handlePrev, handleNext}) => {
    const { bgImage, headline, subheader, buttonText } = block;

    return (
        <div className="maps-section-block" style={{backgroundImage: `url('${bgImage}')`}}>
            <SwiperButton onClick={handlePrev} inverted />
            <div className="maps-section-block-content">
                <Callout
                    headline={headline}
                    description={subheader}
                    buttonText={buttonText}
                    buttonLink={generateRoutePath().replace('home', '')}
                    align="center"
                />
            </div>
            <SwiperButton onClick={handleNext} />
        </div>
    )
}

MapsSectionBlock.propTypes = {
    block: PropTypes.object,
    handlePrev: PropTypes.func,
    handleNext: PropTypes.func
}

MapsSectionBlock.defaultProps = {
    block: {},
    handlePrev: fn => fn,
    handleNext: fn => fn
};

export default MapsSectionBlock;
